

































import StorageMixin from '@/mixins/StorageMixin';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';

@Component
export default class DateRange extends StorageMixin {
  @Prop({ default: 'Диапазон дат' })
  readonly label!: string;

  @Prop({ default: false })
  readonly disabled!: boolean;

  visibleDatePicker = false

  dates: string[] = ['2020-11-10', '2020-11-27']

  get dateRangeText() {
    return this.dates.map((date) => {
      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    }).join(' - ');
  }

  mounted() {
    this.setDates();
    this.$bus.$on('clear-filters', () => this.setDefaultDates());
  }

  setDates() {
    let { dateFrom, dateTo } = this.$route.query;
    if (!dateFrom || !dateTo) {
      dateFrom = this.getFromStorage('date_from');
      dateTo = this.getFromStorage('date_to');
    }
    if (dateFrom && dateTo) {
      this.dates = [String(dateFrom), String(dateTo)];
    } else {
      this.setDefaultDates();
    }
  }

  setDefaultDates() {
    const dateNow = new Date();
    const dateAgo = new Date();
    dateAgo.setMonth(dateAgo.getMonth() - 1);
    dateAgo.setDate(1);
    this.dates = [dateAgo.toISOString().split('T')[0], dateNow.toISOString().split('T')[0]];
  }

  closeDatePickerRange(values: string[]) {
    if (values.length === 2) {
      this.visibleDatePicker = false;
    }
  }

  @Watch('dates')
  datesChanged() {
    if (this.dates.length === 2) {
      if (new Date(this.dates[0]) > new Date(this.dates[1])) {
        this.dates.reverse();
      }
      const { dateFrom, dateTo } = this.$route.query;
      if (dateFrom !== this.dates[0] || dateTo !== this.dates[1]) {
        this.setToStorage('date_from', this.dates[0]);
        this.setToStorage('date_to', this.dates[1]);

        const query = { ...this.$route.query, dateFrom: this.dates[0], dateTo: this.dates[1] };
        this.$router.replace({ query });
      }

      this.$emit('datesChanged', this.dates);
    }
  }
}
